import script from "./AdminSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSchedule.vue?vue&type=script&setup=true&lang=js"

import "./AdminSchedule.vue?vue&type=style&index=0&id=03d13222&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d13222"]])

export default __exports__